module.exports = "/_next/static/images/validating-screen-0c8d6d81ac423ae054ccca58a64d1ab2.svg";